import React from 'react';
import { useNavigate } from 'react-router-dom';
import BulkQuestionUpload from '../components/BulkQuestionUpload';
import { ArrowLeftIcon, DocumentTextIcon } from '@heroicons/react/24/outline';

const AdminBulkUploadPage = () => {
  const navigate = useNavigate();

  const handleUploadComplete = (result) => {
    console.log('Bulk upload completed:', result);
    setTimeout(() => {
      navigate('/admin/dashboard/questions');
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/admin/dashboard/questions')}
              className="mr-4 p-2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
            >
              <ArrowLeftIcon className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-3xl font-bold text-gray-900 flex items-center">
                <DocumentTextIcon className="w-8 h-8 text-blue-600 mr-3" />
                Bulk Question Upload
              </h1>
              <p className="text-gray-600 mt-1">
                Upload multiple questions to the question bank quickly from PDF or DOCX files
              </p>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4">📋 Upload Methods</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <h3 className="font-semibold text-green-800 mb-2">✅ CSV Upload (Recommended)</h3>
              <p className="text-sm text-green-700 mb-2">Fastest and most accurate method</p>
              <ul className="text-sm text-green-600 space-y-1">
                <li>• Questions + answers in one file</li>
                <li>• Automatic answer matching</li>
                <li>• Support for explanations</li>
                <li>• Multiple choice options</li>
              </ul>
            </div>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h3 className="font-semibold text-blue-800 mb-2">📄 PDF/DOCX Upload</h3>
              <p className="text-sm text-blue-700 mb-2">Parse from existing documents</p>
              <ul className="text-sm text-blue-600 space-y-1">
                <li>• Upload question file</li>
                <li>• Upload separate answer file</li>
                <li>• Manual review required</li>
                <li>• Good for existing documents</li>
              </ul>
            </div>
          </div>
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4">
            <h4 className="font-medium text-amber-800 mb-2">💡 CSV Format Example:</h4>
            <code className="text-xs text-amber-700 block mb-2">
              question,optionA,optionB,optionC,optionD,correctOption,explanation
            </code>
            <p className="text-sm text-amber-700">
              Use A, B, C, D for correctOption. All questions will maintain their order when saved to bank.
            </p>
          </div>
        </div>

        {/* Bulk Upload Component */}
        <BulkQuestionUpload onComplete={handleUploadComplete} />
      </div>
    </div>
  );
};

export default AdminBulkUploadPage;
